module.exports = __webpack_public_path__ + "img/footer-logo-white.8773749c.png";